import "../styles/who.scss";
import "../styles/who_mobile.scss";
import {useSelector} from "react-redux";
import { selectAdescos } from "../features/counterSlice";
import {useState,useEffect} from "react";

const Who =()=>{
    const p=useSelector(selectAdescos);

    const [data,set_data]=useState(null);

    useEffect(()=>{
        if(p==null) return;
        const res=p.filter((item)=>{
            return item.id==113;
        })
        
        if(res.length==0) return;
        set_data(res[0]);
    },[p])
	
    return(
        <div className="who">
            <div className="content">
                <p className="m-0 p-0 text-3xl  font-bold">{data?.title.rendered}</p>
                <div dangerouslySetInnerHTML={{__html:data?.acf.description}} className="text-sm -mt-5"/>
            </div>
        </div>
    );
}
export default Who;